import React, { FC } from 'react';
import { ConfigProvider, Table } from 'antd';
import type { TableProps } from 'antd';

const ScrollablePermissionsTable: FC<TableProps<any>> = props => (
  <ConfigProvider
    theme={{
      components: {
        Table: {
          rowHoverBg: '#eef1f5',
          bodySortBg: '#fff'
        }
      }
    }}
  >
    <div className="sec-tree-permissions-table-wrap">
      <Table {...props} />
    </div>
  </ConfigProvider>
);

export default ScrollablePermissionsTable;
